import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CARDS } from '../card';
import { SECTIONS } from '../section';

import { ButtonLinkComponent } from '../button/button-link/button-link.component';

@Component({
  selector: 'lumiron-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule, ButtonLinkComponent, CARDS, SECTIONS],
})
export class FooterComponent {}
